import { render, staticRenderFns } from "./amisSetup.vue?vue&type=template&id=c38864f6"
import script from "./amisSetup.vue?vue&type=script&lang=js"
export * from "./amisSetup.vue?vue&type=script&lang=js"
import style0 from "./amisSetup.vue?vue&type=style&index=0&id=c38864f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports